<template>
  <div>
    <el-button type="success" icon="el-icon-plus" @click="dialogVisible = true">添加新的地址</el-button>
    <el-dialog title="添加币种" width="1200px" :visible.sync="dialogVisible" @close="closeDialog">
      <el-form label-width="200px" :model="coinAddress" :rules="rules" ref="addressForm">
        <el-form-item label="币种" :label-width="formLabelWidth">
          <el-autocomplete
            class="inline-input"
            v-model="coinAddress.coinType"
            :fetch-suggestions="querySearch"
            placeholder="请输入币种">
            <i
              class="el-icon-close el-input__icon"
              slot="suffix"
              @click="cleanSearchCoin"
              style="cursor:pointer;">
            </i>
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="地址" :label-width="formLabelWidth">
          <el-input placeholder="请输入用户地址" clearable v-model="coinAddress.address">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </el-form-item>
        <el-form-item label="memo" :label-width="formLabelWidth">
          <el-input placeholder="请输入地址memo" clearable v-model="coinAddress.memo">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave('addressForm')">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import './../../store';
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';


export default {
  name: "CreateAddress",
  data() {
    return {
      dialogVisible: false,
      coinAddress : {
        coinType: '',
        address: '',
        memo: ''
      },
      rules: {
        "coinType": [{ required: true, message: "请选择币种" }],
        "address": [{ required: true, message: "请输入币种地址" }]
      },
      formLabelWidth: '120px'
    };
  },
  computed: {
    ...mapState('UserCoinAddress', ['addressList', 'allCoins'])
  },
  methods: {
    ...mapActions('UserCoinAddress', [
      'create',
      'getAllCoins'
    ]),
    cleanSearchCoin() {
      this.coinType = '';
    },
    querySearch(queryString, cb) {
      var results = [];
      var coinList = this.allCoins;
      results = queryString ? coinList.filter(this.createFilter(queryString)) : coinList;
      results = results.map((v, i, arr) => {
        return {
          value: v
        };
      });
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      let tempData = this.allCoins;
      return (tempData) => {
        return (tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    handleSave(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.create( {
            coinType : this.coinAddress.coinType, 
            address  : this.coinAddress.address,
            memo  : this.coinAddress.memo
            }).then(() => {
            this.$message.success("添加成功！");
            this.dialogVisible = false;
            this.$emit("refresh", { page: 1 });
          });
        }
      });
    },
    closeDialog() {
      this.coinAddress = {
        coinType: '',
        address: '',
        memo: ''
      };
      this.$refs["addressForm"].resetFields();
    }
  },
  created() {
    this.getAllCoins();
  }
};
</script>

<style lang="less" scoped>
</style>
